import { useEffect, useState } from 'react'
import { ThemeColors } from '../../models/colorTypes'
import { defaultThemeDark } from '../../models/colors'

const useThemeColors = (instanceId?: string): ThemeColors => {
  const [current, setCurrent] = useState<ThemeColors>(defaultThemeDark)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_themeColors', ((e: CustomEvent) => handleChange(e)) as EventListener)
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_themeColors'))

    return () => {
      document.removeEventListener('retorik_themeColors', ((e: CustomEvent) => handleChange(e)) as EventListener)
    }
  }, [])

  return current
}

export default useThemeColors
